import { render, staticRenderFns } from "./TibBannerEditModal.vue?vue&type=template&id=4a0a3a6d"
import script from "./TibBannerEditModal.vue?vue&type=script&lang=js"
export * from "./TibBannerEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports